<template>
  <div class="report-recipient-input">
    <v-row class="pb-0 flex-grow-0">
      <v-col>{{ $t('admin_report.report_recipients') }}</v-col>
    </v-row>
    <div class="report-recipient-input-inputs">
      <v-form ref="form"
              v-model="isFormValid">
        <div v-for="(item, idx) in emailRecipients"
             :key="idx">
          <v-select outlined
                    :placeholder="$t('admin_report.report_recipients')"
                    :items="operatorOptions"
                    v-model="emailRecipients[idx]"
                    :rules="rules"
                    clearable
                    @input="onEmailRecipientInput(idx)"></v-select>
        </div>
      </v-form>
    </div>
    <v-row class="flex-grow-0 pa-4">
      <v-spacer></v-spacer>
      <v-btn :disabled="!isFormValid"
             @click="saveEmailRecipients">Save</v-btn>
    </v-row>
  </div>
</template>

<script>
import {computed, onMounted, ref} from "@vue/composition-api";

export default {
  name: 'ReportRecipientInput',
  props: {
    type: String,
  },
  setup(props, {root, emit}) {
    const emailRecipients = ref([]);

    const isFormValid = ref(true);
    const rules = ref([
      value => _.filter(emailRecipients.value, (a) => a === value).length === 1 || 'Duplicated',
    ]);
    const getEmailRecipients = function () {
      root.$callAPI('aafb/admin/report/recipients/', {
        type: props.type,
      }, function (response) {
        if (response.body.success) {
          emailRecipients.value = [..._.filter(JSON.parse(response.body.recipients.recipients)), ''];
        }
      });
    }
    const onEmailRecipientInput = function (idx) {
      if (emailRecipients.value.length === idx + 1) {
        if (emailRecipients.value[idx]) {
          emailRecipients.value.splice(idx + 1, 0, '');
        }
      } else if (!emailRecipients.value[idx]) {
        emailRecipients.value.splice(idx, 1);
      }
    };

    const operators = ref([]);
    const operatorOptions = computed(() => {
      return operators.value.map((u) => {
        return {text: `${u.account.email}`, value: u.account.id};
      })
    });
    const getOperators = function () {
      root.$callAPI('hkiarace/admin/operator/', {page_size: -1}, function (response) {
        operators.value = response.body.operators;
      });
    };

    const saveEmailRecipients = function () {
      root.$callAPI('aafb/admin/report/recipients/set/', {
        type: props.type,
        recipients: JSON.stringify(_.filter(emailRecipients.value)),
      }, function (response) {
        if (response.body.success) {
          getEmailRecipients();
        }
      });
    }

    onMounted(() => {
      getOperators();
      getEmailRecipients();
    })

    return {
      isFormValid,
      rules,
      operatorOptions,
      emailRecipients,
      onEmailRecipientInput,
      saveEmailRecipients,
    }
  },
}
</script>

<style lang="less">
.report-recipient-input {
  flex: 1 1 0;
  display: flex;
  flex-direction: column;

  overflow: hidden;

  .report-recipient-input-inputs {
    flex: 1 1 0;
    overflow: auto;
  }
}
</style>
